import React from 'react'
import styles from './Button.module.css'

const Button = (props: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) => {
  return <button {...props} className={styles.button} />
}

export default Button
